import { useNewBannerStore } from 'stores/banner/create'
import { useScanRegistryStore } from 'stores/scans/registry'
import { useOnboardingStore } from 'stores/account/onboarding'

const STORES_WITH_RESET = [useNewBannerStore, useScanRegistryStore, useOnboardingStore]

export function resetStores() {
  localStorage.clear()
  sessionStorage.clear()

  STORES_WITH_RESET.forEach((storeInit) => {
    const store = storeInit()
    store.resetState?.()
  })
}
